/**
 * @ngdoc directive
 * @name accordion
 *
 * @description
 * Page accordion
 */
module.directive('accordion', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            id: '@?',
            label: '@',
            subtitle: '@?',
            infos: '@?',
            small: '@?',
            opened: '=?',
            boutonaction: '&?',
            boutontext: '@?',
            boutondisabled: '=?',
            boutonshow: '=?',
            boutonclass: '@?',
        },
        link: function ($scope) {
            $scope.opened = $scope.opened || false;
            $scope.toggleAccordion = function () {
                $scope.opened = !$scope.opened;

                if ($scope.opened) {
                    $scope.$emit('accordion_opening', {id_accordion: $scope.id});
                }
            };
        },
        templateUrl: 'src/components/accordion/accordion.html'
    };
});

/**
 * @ngdoc directive
 * @name accordions
 *
 * @description
 * Bloc of accordions
 */
module.directive('accordions', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            id: '@?',
            label: '@',
            content: '='
        },
        template:
                '<div class="aqua-accordions">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-accordions--title">{{label}}</span></h2>' +
                '    <accordion ng-repeat="accordion in content track by $index" label="{{accordion.field_title}}">' +
                '      <div class="grid-12" ng-bind-html="accordion.field_content | trustAsHtml"></div>' +
                '    </accordion>' +
                '  </div>' +
                '</div>'
    };
});